module.exports = __webpack_public_path__ + "img/login.d8415675.png";